/* ---------------------------------------------------------------------------
   Hodalump — Kachelmenue der mobilen Navigation
   ---------------------------------------------------------------------------
   Gehoert zu snippets/mobile-nav.liquid, Zweig `section_st.mbtiles`.

   WARUM EINE EIGENE DATEI
   Das Snippet laeuft am Ende durch `strip_newlines | remove: '  ' | remove
   Tabulator`, und seine Ausgabe ein zweites Mal in
   sections/header-menu-inline.liquid. Ein eingebettetes Skript wuerde dabei zu
   einer einzigen Zeile zusammengezogen und um alle Doppelleerzeichen gekuerzt.
   Als Asset-Datei ist es davon unberuehrt.

   WAS ES MACHT
   Zwei Ebenen: die Unterebenen liegen fertig im Markup und werden nur ein- und
   ausgeblendet. Ohne dieses Skript bleibt das Menue benutzbar - dann sind die
   Unterebenen schlicht nicht erreichbar, die Hauptkacheln fuehren aber weiter.

   DIE KOPFZEILE GEHOERT DEM THEME
   Der Zurueck-Pfeil wird nicht neu gebaut, sondern in die vorhandene
   `.mobile-nav__header` eingehaengt. Deren Schliessen-Knopf `.close-menu` wird
   dabei nicht angefasst: theme.js bindet ihn ohne Null-Pruefung, ein Entfernen
   wuerde den gesamten Burger lahmlegen.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.hdKachelmenue) { return; }
  window.hdKachelmenue = true;

  /* Die acht Vorschaubilder der Startebene tragen im Markup nur data-src.
     Grund: Das Menue liegt technisch im sichtbaren Bereich und ist lediglich
     zur Seite geschoben - loading="lazy" greift dort nicht, der Browser hielt
     die Bilder fuer noetig und lud sie beim Seitenaufruf. Gemessen am
     09.09.2026: 42 kB und acht Anfragen zwischen 0,96 und 1,3 Sekunden, also
     mitten im kritischen Fenster, wo sie dem ersten Produktbild die Leitung
     wegnahmen. Jetzt werden sie erst geholt, wenn jemand das Menue oeffnet.
     Die Bilder der Unterebenen machen das ueber loading="lazy" bereits
     richtig - sie laden erst beim Abtauchen. */
  function vorschauHolen(bereich) {
    var bilder = bereich.querySelectorAll('img.hd-km__vorschau[data-src]');
    for (var i = 0; i < bilder.length; i++) {
      var b = bilder[i];
      if (b.dataset.srcset) { b.setAttribute('srcset', b.dataset.srcset); }
      b.setAttribute('src', b.dataset.src);
      b.removeAttribute('data-src');
      b.removeAttribute('data-srcset');
    }
  }

  function einrichten(wurzel) {
    var fenster = wurzel.querySelector('.hd-km__fenster');
    if (!fenster) { return; }

    /* Direkt an den Schaltflaechen horchen, nicht am Dokument: ein Zuhoerer am
       Dokument liefe bei JEDEM Klick im Shop mit, auch auf Produktseiten, die
       mit dem Menue nichts zu tun haben - und ausgerechnet dort ist die
       Reaktionszeit ohnehin knapp. theme.js bindet dieselben Knoepfe ueber die
       Klasse; zwei Zuhoerer am selben Element stoeren einander nicht.
       Erfassungsphase (true), damit die Bilder schon unterwegs sind, waehrend
       das Menue aufklappt. { once: true } genuegt: Danach tragen die Bilder
       ihr src und es gibt nichts mehr zu tun. */
    var knoepfe = document.querySelectorAll('.nav_toggle');
    for (var n = 0; n < knoepfe.length; n++) {
      knoepfe[n].addEventListener('click', function () {
        vorschauHolen(wurzel);
      }, { capture: true, once: true });

      /* 10.09.2026: zusaetzlich schon beim Aufsetzen des Fingers. Zwischen
         pointerdown und click liegen auf Touchgeraeten regelmaessig 100 bis
         300 ms — die hat der Browser dann bereits fuer den Bildabruf genutzt. */
      knoepfe[n].addEventListener('pointerdown', function () {
        vorschauHolen(wurzel);
      }, { capture: true, once: true, passive: true });
    }

    /* ----------------------------------------------------------------------
       10.09.2026: Vorladen im Leerlauf.

       Bisher startete der Abruf erst beim Oeffnen. Das haelt zwar den
       kritischen Pfad frei — die acht Bilder wogen 42 kB und liefen vorher
       zwischen 0,96 und 1,3 s, genau dort, wo das erste Produktbild die
       Leitung braucht —, aber wer das Menue antippt, wartet dann eben beim
       Oeffnen.

       Beides zusammen geht: Nach dem load-Ereignis, wenn der Browser nichts
       Dringenderes zu tun hat, werden die Bilder still nachgeholt. Der
       kritische Pfad bleibt unberuehrt, und beim Oeffnen sind sie da.

       requestIdleCallback laeuft nur, wenn wirklich Leerlauf ist; Safari
       kennt es bis heute nicht, deshalb der Rueckfall auf setTimeout. Die
       Sperre in vorschauHolen (`[data-src]` im Selektor) sorgt dafuer, dass
       ein spaeterer Klick nichts doppelt holt.
       ---------------------------------------------------------------------- */
    /* 10.09.2026: Auch die Bilder der Unterebenen mitnehmen.

       Es sind 21 Stueck, alle 108 px breit — zusammen rund 85 kB. Sie
       standen auf loading="lazy" und wurden deshalb erst geholt, wenn
       jemand in eine Unterebene abtauchte; dort wartete man dann. Im
       Leerlauf nach dem Seitenaufbau kosten sie nichts Spuerbares.

       `loading = 'eager'` statt eines eigenen Vorladers: Der Browser
       waehlt so weiterhin die richtige Fassung aus srcset und sizes.
       Bereits geladene Bilder ignorieren die Zuweisung. */
    function unterebenenHolen(bereich) {
      var bilder = bereich.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < bilder.length; i++) {
        bilder[i].setAttribute('loading', 'eager');
      }
    }

    /* ABSTAND ZUM KRITISCHEN FENSTER — nachgemessen und nachgebessert.

       Der erste Anlauf haengte das Vorladen direkt an `load` plus
       requestIdleCallback. Gemessen am 10.09.2026 startete der erste
       Menuebild-Abruf dann bei 670 ms, waehrend der LCP erst bei 1.247 ms
       fiel: Die 29 Bilder liefen also wieder mitten in das Fenster, aus dem
       sie am 09.09. gerade herausgenommen worden waren.

       Deshalb zwei Sekunden Abstand nach `load`. Der LCP liegt auf
       Produktseiten im Feld bei 1.165 ms (p75) — nach zwei Sekunden ist er
       praktisch immer durch. Wer das Menue frueher antippt, loest den Abruf
       ohnehin ueber pointerdown selbst aus; dann ist das Vorladen nur noch
       eine Bequemlichkeit fuer den zweiten Blick.

       requestIdleCallback obendrauf, damit die Bilder auch dann warten,
       wenn der Hauptthread gerade beschaeftigt ist. */
    function imLeerlaufHolen() {
      function alles() {
        vorschauHolen(wurzel);
        unterebenenHolen(fenster);
      }
      function gleich() {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(alles, { timeout: 4000 });
        } else {
          alles();
        }
      }
      window.setTimeout(gleich, 2000);
    }

    if (document.readyState === 'complete') {
      imLeerlaufHolen();
    } else {
      window.addEventListener('load', imLeerlaufHolen, { once: true });
    }

    var kopf = document.querySelector('.mobile-nav__header');
    var titel = kopf ? kopf.querySelector('.mobile-nav__title') : null;
    if (!kopf || !titel) { return; }

    var startTitel = titel.textContent;
    var offen = null;

    /* Zurueck-Pfeil vor den Titel setzen. Er ist bis zum ersten Abtauchen
       unsichtbar, belegt aber schon seinen Platz - sonst ruecken beim Oeffnen
       einer Unterebene alle Kopfelemente zur Seite. */
    var zurueck = document.createElement('button');
    zurueck.type = 'button';
    zurueck.className = 'hd-km__zurueck';
    zurueck.setAttribute('aria-label', 'Eine Ebene zurück');
    /* Eigenes Chevron statt des Theme-Pfeils: der `#icon-arrow` des Themes ist
       ein duenner Strich, der auf hellem Grund kaum zu sehen war. */
    zurueck.innerHTML =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
      ' stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M15 18l-6-6 6-6"/></svg>';
    kopf.insertBefore(zurueck, kopf.firstChild);

    function oeffnen(ziel) {
      var e = fenster.querySelector('[data-hd-ebene="' + ziel + '"]');
      if (!e) { return; }
      e.hidden = false;
      /* Doppeltes requestAnimationFrame: der Startzustand muss einmal
         angewendet worden sein, sonst springt die Ebene ohne Uebergang an
         ihren Platz. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { e.classList.add('hd-km--offen'); });
      });
      e.scrollTop = 0;
      offen = e;
      titel.textContent = e.getAttribute('data-hd-name') || startTitel;
      zurueck.classList.add('hd-km--da');
    }

    function schliessen() {
      if (!offen) { return; }
      var e = offen;
      e.classList.remove('hd-km--offen');
      window.setTimeout(function () {
        if (!e.classList.contains('hd-km--offen')) { e.hidden = true; }
      }, 300);
      offen = null;
      titel.textContent = startTitel;
      zurueck.classList.remove('hd-km--da');
    }

    wurzel.addEventListener('click', function (ev) {
      var k = ev.target.closest ? ev.target.closest('[data-hd-ziel]') : null;
      if (!k || !wurzel.contains(k)) { return; }
      ev.preventDefault();
      oeffnen(k.getAttribute('data-hd-ziel'));
    });

    zurueck.addEventListener('click', function (ev) {
      ev.preventDefault();
      schliessen();
    });

    /* Wird das ganze Menue geschlossen, faellt es auf die erste Ebene zurueck.
       Sonst stuende beim naechsten Oeffnen noch die Unterebene von vorhin da. */
    document.addEventListener('click', function (ev) {
      var z = ev.target.closest ? ev.target.closest('.close-menu, .modal-overly') : null;
      if (z) { window.setTimeout(schliessen, 320); }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && offen) { schliessen(); }
    });

    /* Rueckfallebene fuer Sprache und Waehrung. Die beiden Auswahlfelder haben
       ein onchange am Element; wird das durch ein anderes Skript oder eine
       Inhaltsrichtlinie verschluckt, passiert beim Umstellen nichts. Der
       Listener hier haengt am Container und greift auch dann. Doppeltes
       Absenden ist ausgeschlossen: nach dem ersten submit laedt die Seite neu. */
    var fuss = wurzel.parentNode ? wurzel.parentNode.querySelector('.hd-km__fuss') : null;
    if (fuss) {
      fuss.addEventListener('change', function (ev) {
        var s = ev.target;
        if (!s || s.tagName !== 'SELECT' || !s.form) { return; }
        if (s.form.dataset.hdGesendet) { return; }
        s.form.dataset.hdGesendet = '1';
        s.form.submit();
      });
    }
  }

  function start() {
    var alle = document.querySelectorAll('.hd-km');
    for (var i = 0; i < alle.length; i++) { einrichten(alle[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
